/**
 * Shared UK date formatting — single source of truth so every list,
 * chart caption, timeline and PDF header shows the same "8th July
 * 2026" shape. Handles both `YYYY-MM-DD` and full ISO strings, and
 * falls back to the raw input on parse failure so a bad server value
 * stays visible instead of "Invalid Date".
 */

const ordinal = (n) => {
  if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
  switch (n % 10) {
    case 1: return `${n}st`;
    case 2: return `${n}nd`;
    case 3: return `${n}rd`;
    default: return `${n}th`;
  }
};

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** "8th July 2026" — the app-wide standard human date. */
export const formatDate = (v) => {
  if (!v) return '—';
  const s = String(v);
  const d = new Date(s.length === 10 ? `${s}T00:00:00` : s);
  if (isNaN(+d)) return s;
  return `${ordinal(d.getDate())} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

/** "8th July 2026 · 14:32" — same date + 24h time for audit rows. */
export const formatDateTime = (v) => {
  if (!v) return '—';
  const s = String(v);
  const d = new Date(s.length === 10 ? `${s}T00:00:00` : s);
  if (isNaN(+d)) return s;
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${formatDate(d)} · ${hh}:${mm}`;
};
